import { OperationStatuses } from "../operationsInterfaces";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers";
import * as Parameters from "../models/parameters";
import { DevCenterClient } from "../devCenterClient";
import {
  OperationStatusesGetOptionalParams,
  OperationStatusesGetResponse,
} from "../models";

/** Class containing OperationStatuses operations. */
export class OperationStatusesImpl implements OperationStatuses {
  private readonly client: DevCenterClient;

  /**
   * Initialize a new instance of the class OperationStatuses class.
   * @param client Reference to the service client
   */
  constructor(client: DevCenterClient) {
    this.client = client;
  }

  /**
   * Get the status of an operation.
   * @param projectName Name of the project.
   * @param operationId The operation id name.
   * @param options The options parameters.
   */
  get(
    projectName: string,
    operationId: string,
    options?: OperationStatusesGetOptionalParams,
  ): Promise<OperationStatusesGetResponse> {
    return this.client.sendOperationRequest(
      { projectName, operationId, options },
      getOperationSpec,
    );
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const getOperationSpec: coreClient.OperationSpec = {
  path: "/projects/{projectName}/operationstatuses/{operationId}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.OperationStatus,
    },
    default: {
      bodyMapper: Mappers.AzureCoreFoundationsErrorResponse,
      headersMapper: Mappers.OperationStatusesGetExceptionHeaders,
    },
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [
    Parameters.endpoint,
    Parameters.projectName,
    Parameters.operationId,
  ],
  headerParameters: [Parameters.accept],
  serializer,
};
